import { useCallback, useState } from "react"

interface UseEntityLockConflictDialogParams {
  onRefresh?: () => void
  markLost: () => void
}

export interface UseEntityLockConflictDialogReturn {
  isLockConflictOpen: boolean
  lockConflictMessage: string | null
  openLockConflict: (message: string) => void
  closeLockConflict: () => void
  handleLockConflictRefresh: () => void
}

export const useEntityLockConflictDialog = ({
  onRefresh,
  markLost,
}: UseEntityLockConflictDialogParams): UseEntityLockConflictDialogReturn => {
  const [isLockConflictOpen, setIsLockConflictOpen] = useState(false)
  const [lockConflictMessage, setLockConflictMessage] = useState<string | null>(null)

  const openLockConflict = useCallback(
    (message: string) => {
      markLost()
      setLockConflictMessage(message)
      setIsLockConflictOpen(true)
    },
    [markLost]
  )

  const closeLockConflict = useCallback(() => {
    setIsLockConflictOpen(false)
  }, [])

  const handleLockConflictRefresh = useCallback(() => {
    setIsLockConflictOpen(false)
    onRefresh?.()
  }, [onRefresh])

  return {
    isLockConflictOpen,
    lockConflictMessage,
    openLockConflict,
    closeLockConflict,
    handleLockConflictRefresh,
  }
}
